import {
  INextgenSubscription,
  ISubscription
} from "@wingspanhq/users/dist/lib/interfaces";
import { selectorIsNextGenSubscriptionEnded } from "./selectorIsNextGenSubscriptionEnded";
import { selectorIsSubscriptionEnded } from "./selectorIsSubscriptionEnded";

export interface HasOnlyEndedSubscriptionsInput {
  subscription?: ISubscription;
  nextGenSubscriptions?: INextgenSubscription[];
  now?: Date;
}

// True only when the user has at least one subscription record and every
// record is ended. Users with no subscription records at all return false
// so their surfaces keep the pre-existing behavior.
export const selectorHasOnlyEndedSubscriptions = ({
  subscription,
  nextGenSubscriptions,
  now = new Date()
}: HasOnlyEndedSubscriptionsInput): boolean => {
  const hasAnySubscription =
    !!subscription || (nextGenSubscriptions || []).length > 0;

  return (
    hasAnySubscription &&
    (!subscription || selectorIsSubscriptionEnded(subscription)) &&
    (nextGenSubscriptions || []).every(nextGenSubscription =>
      selectorIsNextGenSubscriptionEnded({
        subscription: nextGenSubscription,
        now
      })
    )
  );
};
